import React, { useCallback } from 'react';
import { moduleScnMap } from 'utils/code';

const Popup = ({ dispensingData, setDispensingData, confirmModule, title, modules }) => {
  const editDispensingData = useCallback((key, data) => {
    setDispensingData((dispensingData) => {
      return {
        ...dispensingData,
        [key]: data
      }
    });
  }, [setDispensingData])

  const editModuleData = useCallback((moduleIdx) => {
    let modelNo = '';
    let moduleScnNm = '';
    let moduleTypeNm = '';
    
    modules.forEach(module => {
      if (module.moduleIdx === Number(moduleIdx)) {
        modelNo = module.modelNo;
        moduleScnNm = moduleScnMap[module.moduleScn + ''].title;
        moduleTypeNm = module.moduleType === "DT" ? "이동형" : "휴대형";
      }
    });

    setDispensingData((dispensingData) => {
      return {
        ...dispensingData,
        moduleIdx: moduleIdx,
        modelNo: modelNo,
        moduleScnNm: moduleScnNm,
        moduleTypeNm: moduleTypeNm,
      }
    });
  }, [modules, setDispensingData])

  const convertTelType = useCallback((value) => {
    const deleteNotNumberStrings = value.replace(/(\D)+/g, '');
    const result = value.length > 7 ? 
                     `${deleteNotNumberStrings.substring(0, 3)}-${deleteNotNumberStrings.substring(3, 7)}-${deleteNotNumberStrings.substring(7, 11)}` : 
                     value.length > 3 ? `${deleteNotNumberStrings.substring(0, 3)}-${deleteNotNumberStrings.substring(3, 7)}` : 
                                        deleteNotNumberStrings;
    editDispensingData('userTel', result);
  }, [editDispensingData])

  return (
    <>
      <div>
        <p>장치정보</p>
        <select onChange={({ target: { value }}) => { editModuleData(value + "") }}
                defaultValue={dispensingData.moduleIdx}>
          <option value="0">장치정보를 선택해주세요</option>
          {
            modules && modules.map(module => {
              return (
                <option key={module.moduleIdx}
                        value={module.moduleIdx}
                        style={{color: module.calibration !== null && 
                                       ((new Date(module.calibration.deadline) - new Date()) / 8.64e+7) < 31 ? '#ff0000' : '#000'}}
                        disabled={module.calibration !== null && 
                                  ((new Date(module.calibration.deadline) - new Date()) / 8.64e+7) < 31}
                        >
                  {module.modelNm}
                </option>
              )
            })
          }
        </select>
      </div>
      <div>
        <p>고유번호</p> 
        <input type="text" value={dispensingData.modelNo} readOnly/> 
      </div>
      <div>
        <p>검지유형</p> 
        <input type="text" value={dispensingData.moduleScnNm} readOnly/> 
      </div>
      <div>
        <p>운용유형</p> 
        <input type="text" value={dispensingData.moduleTypeNm} readOnly/> 
      </div>
      <div>
        <p>협력업체명<br/>(필요시)</p>
        <input type="text" 
                value={dispensingData.partner}
                onChange={({ target: { value }}) => { editDispensingData('partner', value) }} /> 
      </div>
      <div>
        <p>사용자</p>
        <input type="text" 
                value={dispensingData.userNm}
                onChange={({ target: { value }}) => { editDispensingData('userNm', value) }} /> 
      </div>
      <div>
        <p>연락처</p>
        <input type="text" 
                value={dispensingData.userTel}
                onKeyUp={({ target: { value }}) => { convertTelType(value) }}
                onChange={({ target: { value }}) => { editDispensingData('userTel', value) }}
                maxLength="13" />
      </div>
      <div>
        <p>관리감독자</p> 
        <input type="text" 
                value={dispensingData.instNm}
                onChange={({ target: { value }}) => { editDispensingData('instNm', value) }} /> 
      </div>
      <div>
        <p>위치정보</p>
        <input type="text" 
               value={dispensingData.areaNm}
               onChange={({ target: { value }}) => { editDispensingData('areaNm', value) }} />
      </div>
      <div>
        <button className="submitBtn" onClick={() => confirmModule()}>
          {title}
        </button>
      </div>
    </>
  )
}

export default Popup;